module.exports = {
      id: "author-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#author",
      toString: function () {
        return this.url;
      }
    }